import { UniversalLinksComponent } from './universal-links/universal-links.component';
import { Component, HostListener } from '@angular/core';

import { NavController, Platform } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { AuthService } from './services/auth.service';
import { Storage } from '@ionic/storage';
import { ApiService } from './services/api.service';
// import { SocketService } from './services/socket.service';
import { RootServices } from './services/root.services';
import { CurrencyPipe, DatePipe, DecimalPipe } from '@angular/common';
import { ImagePicker } from '@ionic-native/image-picker/ngx';
import { CommonService } from './services/common.service';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { FileTransfer } from '@ionic-native/file-transfer/ngx';
import { File } from '@ionic-native/file/ngx';
import { AppComponentProcessor } from './app.component.processor';
import { Deeplinks } from '@ionic-native/deeplinks/ngx';
import { AccountModel } from './model/account.model';
import { filter, retry } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { Printer } from '@awesome-cordova-plugins/printer/ngx';
import { DocumentScannerOptions } from '@awesome-cordova-plugins/document-scanner/ngx';
// import { Printer } from '@awesome-cordova-plugins/printer/ngx';
import { ChangeDetectorRef } from '@angular/core';

// import * as $ from 'jquery';
declare const $: any;

// declare const $: any;
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  // providers: [DatePipe],
  providers: [DecimalPipe, CurrencyPipe]
})
export class AppComponent {

  processor: AppComponentProcessor;
  account: AccountModel = {};

  constructor(
    public platform: Platform,
    public splashScreen: SplashScreen,
    public statusBar: StatusBar,
    public authService: AuthService,
    public storage: Storage,
    public apiService: ApiService,
    // public socketService: SocketService,
    public rootServices: RootServices,
    public datePipe: DatePipe,
    public currencyPipe: CurrencyPipe,
    public imagePicker: ImagePicker,
    public commonService: CommonService,
    public iab: InAppBrowser,
    public fileTransfer: FileTransfer,
    public file: File,
    public deeplinks: Deeplinks,
    public navController: NavController,
    public ref: ChangeDetectorRef
    // public printer: Printer,
  ) {
    this.processor = new AppComponentProcessor(
      platform,
      splashScreen,
      statusBar,
      authService,
      storage,
      apiService
      // , socketService
      , rootServices,
      datePipe,
      currencyPipe,
      imagePicker,
      commonService,
      iab,
      fileTransfer,
      file,
      deeplinks,
      navController,
      // printer
    );

    this.rootServices.appComponent = this;

    this.processor.initializeApp();
    this.processor.prepareForFrame();
    this.rootServices.camera.cleanup();
    // this.rootServices.camera.cleanup();

    this.deeplinks.routeWithNavController(this.navController, {
      '/about-us': UniversalLinksComponent,
      '/products/:productId': UniversalLinksComponent
    }).subscribe(match => {
      // match.$route - the route we matched, which is the matched entry from the arguments to route()
      // match.$args - the args passed in the link
      // match.$link - the full link data
      console.log('Successfully matched route', match);
    }, nomatch => {
      // nomatch.$link - the full link data
      console.error('Got a deeplink that didn\'t match', nomatch);
    });

    this.authService.loginState$.pipe(filter(f => f)).subscribe(state => {
      this.apiService.getPromise('/user/users/getInfo', {}).then(userInfo => {
        this.account = userInfo;
      });
    });
    this.authService.user$.pipe(filter(f => !!f)).subscribe(userInfo => {
      this.account = {
        Code: userInfo.id,
        Name: userInfo.name,
        TagName: userInfo.TagName,
        Username: userInfo.username,
        Avatar: userInfo.avatar as any,
        Core: {
          Domain: userInfo.core?.domain,
          Name: userInfo.core?.name,
          Banner: userInfo.core?.banner,
        },
      };
    });
  }

  gotoAccount() {
    this.rootServices.navigate('/account');
    this.rootServices.f7app.panel.close();
  }

  gotoToSettings() {
    this.rootServices.navigate('/settings');
    this.rootServices.f7app.panel.close();
    return true;
  }

  goto(href: string) {
    this.rootServices.navigate(href);
    this.rootServices.f7app.panel.close();
    return true;
  }

  gotoAbout() {
    if (this.rootServices.device.platform == 'browser') {
      this.rootServices.openExtenalLink('https://probox.one');
    } else {
      this.rootServices.navigate('/about');
      this.rootServices.f7app.panel.close();
    }
  }

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    // console.log(event);
    return this.commonService.onKeydownEvent$.next(event);
  }
  @HostListener('document:keyup', ['$event'])
  handleKeyupEvent(event: KeyboardEvent) {
    // console.log(event);
    return this.commonService.onKeyupEvent$.next(event);
  }

}
